import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import RecommendedSites from './components/RecommendedSites';
import HotArticles from './components/HotArticles';
import FAQSection from './components/FAQSection';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '柠檬导航',
    url: 'https://www.lemonnav.cn',
    description: '柠檬导航是一款精心筛选、分类清晰的优质网站导航平台，汇聚海量实用网址资源，助您快速找到所需网站。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.lemonnav.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <SEOHead
        title="柠檬导航 - 精选优质网站导航平台 | 快速找到你需要的网站"
        description="柠檬导航是一款精心筛选、分类清晰的优质网站导航平台，汇聚海量实用网址资源，覆盖工作学习娱乐全场景。200+精选网站、8大核心分类，助您快速找到所需网站，开启高效上网体验。"
        keywords="柠檬导航,网站导航大全,实用网址导航,精选网站目录,上网导航平台,优质网址收录,网站分类导航,快速找网站"
        schemaData={homeSchema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <RecommendedSites />
        <HotArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}